/* eslint-disable no-unused-vars */
export enum FORM_TYPES {
  W2 = 'W2',
  FORM1095C = '1095-C',
}

export interface IYearEndFormUpload {
  year: string;
  companyId: string;
  file: any;
  formType: string;
}
